var map = {
	"./1.svg": "99c7",
	"./2.svg": "91cb",
	"./3.svg": "5939",
	"./4.svg": "2abf",
	"./5.svg": "8c87",
	"./cv_tumbnail.svg": "1ae8"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "e8f5";